import { fetchAuthSession } from 'aws-amplify/auth'

export async function waitForStableSession(timeoutMs = 3000): Promise<void> {
  const start = Date.now()

  while (true) {
    const session = await fetchAuthSession()
    const id = session.tokens?.idToken?.toString()
    const access = session.tokens?.accessToken?.toString()

    if (id && access) {
      return
    }

    if (Date.now() - start > timeoutMs) {
      return
    }

    await new Promise(resolve => setTimeout(resolve, 100))
  }
}
